<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="row m-2">
            <b-row>
              <b-col>
                <b-button
                  class="float-left"
                  variant="primary"
                  size="md"
                  @click="Refresh"
                >
                  <i class="mdi mdi-rotate"></i>
                  <b-spinner v-if="isBusy" small></b-spinner>
                  {{ $t("Refresh") }}
                </b-button>
              </b-col>
            </b-row>
            <div class="col mt-2">
              <b-table-simple
                class="table-bordered w-100 tableStudent"
                :items="items"
                style="height: 500px"
                small="small"
                responsive="md"
                show-empty
                :busy="isBusy"
                striped
                sticky-header="80vh"
                no-border-collapse
                bordered
                hover
              >
                <b-thead>
                  <b-tr>
                    <b-th variant="info" rowspan="2" class="text-center">{{ $t("№") }}</b-th>
                    <b-th variant="info" rowspan="2" class="text-center">{{
                      $t("Xarid turi")
                    }}</b-th>
                    <b-th variant="info" rowspan="2" class="text-center">{{
                      $t("Xarid predmeti")
                    }}</b-th>
                    <b-th variant="info" class="text-center">{{
                      $t("Buydjet buyurtmachisi")
                    }}</b-th>
                    <b-th variant="info" class="text-center">{{
                      $t("Korparativ buyurtmachisi")
                    }}</b-th>
                  </b-tr>
                  <b-tr>
                    <b-th variant="info" class="text-center">{{ $t("(BXM)") }}</b-th>
                    <b-th variant="info" class="text-center">{{ $t("(BXM)") }}</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody
                  v-show="items.length > 0 && !isBusy"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <b-tr>
                    <b-th
                      :rowspan="item.table.length + 1"
                      style="vertical-align: middle"
                    >
                      {{ index + 1 }}
                    </b-th>
                    <b-th
                      :rowspan="item.table.length + 1"
                      style="vertical-align: middle"
                    >
                      <div class="text-left w-space-nowrap">
                        <b-form-input
                        v-model="item.tradetypename"
                        :placeholder="$t('tradetypename')"
                        type="text"
                      ></b-form-input>
                      </div>
                    </b-th>
                  </b-tr>

                  <b-tr v-for="(el, index) in item.table" :key="index + 'tr'">
                    <b-th>
                      <div class="text-left w-space-nowrap"></div>
                      <b-form-input
                        v-model="el.purchaseitem"
                        :placeholder="$t('purchaseitem')"
                        type="text"
                      ></b-form-input>
                    </b-th>
                    <b-th class="text-left w-space-nowrap">
                      <custom-number-input
                        class="ml-n3"
                        :placeholder="$t('budgetcustomers')"
                        v-model="el.budgetcustomers"
                      ></custom-number-input>
                    </b-th>
                    <b-th>
                      <div class="text-left w-space-nowrap">
                        <custom-number-input
                          class="ml-n3"
                          :placeholder="$t('budgetcustomers')"
                          v-model="el.corporatecustomers"
                        ></custom-number-input>
                      </div>
                    </b-th>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <b-row>
                <b-col style="text-align: right !important">
                  <b-button
                    variant="success"
                    :disabled="loadingButton"
                    @click="Update()"
                    class="float-right mt-5"
                  >
                    <b-spinner small v-if="loadingButton"></b-spinner>
                    {{ $t("Save") }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import TradeTypeRestrictionService from "@/services/info/tradetyperestriction.service";
import CustomNumberInput from "../../../components/CustomNumberInput.vue";
export default {
  components: { Layout, PageHeader, Multiselect, CustomNumberInput },
  data() {
    return {
      title: this.$t("TradeTypeRestriction"),
      braedcrumb: [
        {
          text: this.$t("Info"),
        },
        {
          text: this.$t("TradeTypeRestriction"),
          active: true,
        },
      ],
      isLoading: false,
      isBusy:false, 
      loadingButton:false,
      filter: {
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
        perPageOptions: [10, 20, 50, 100],
        totalRows: 0,
      },
      fields: [
        {
          key: "id",
          label: this.$t("id"),
          sort: true,
        },
        {
          key: "code",
          label: this.$t("code"),
          sort: true,
        },
        {
          key: "shortname",
          label: this.$t("shortname"),
          sort: true,
        },
        {
          key: "fullname",
          label: this.$t("fullname"),
          sort: true,
        },
        {
          key: "status",
          label: this.$t("status"),
          sort: true,
        },
        {
          key: "actions",
          label: this.$t("actions"),
          sort: true,
        },
      ],
      items: [
        {
          id: 0,
          tradetypeid: 1,
          tradetypename: "Milliydo`kon.uzex.uz",
          stateid: 1,
          statename: "",
          table: [
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "Tovar",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "Ish yoki xizmatlar",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "Aynan bir turdagi tovar",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "Aynan bir turdagi ish va xizmatlar",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
          ],
        },
        {
          id: 0,
          tradetypeid: 4,
          tradetypename: "To`g`ridan to`gri",
          stateid: 1,
          statename: "",
          table: [
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
          ],
        },
        {
          id: 0,
          tradetypeid: 5,
          tradetypename: "Eng yaxshi taklif",
          stateid: 1,
          statename: "",
          table: [
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
          ],
        },
        {
          id: 0,
          tradetypeid: 6,
          tradetypename: "Auksion",
          stateid: 1,
          statename: "",
          table: [
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
          ],
        },
        {
          id: 0,
          tradetypeid: 2,
          tradetypename: "shop.uzex.uz",
          stateid: 1,
          statename: "",
          table: [
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
          ],
        },
        {
          id: 0,
          tradetypeid: 3,
          tradetypename: "Etender.uzex.uz",
          stateid: 1,
          statename: "",
          table: [
            {
              id: 0,
              ownerid: 0,
              purchaseitem: "",
              budgetcustomers: "",
              corporatecustomers: "",
              Status: 1,
            },
          ],
        },
      ],
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    },
  },
  created() {
    this.Refresh();
  },
  methods: {
    Delete(item) {
      this.DeleteLoading = true;
      TradeTypeRestrictionService.Delete(item.id)
        .then((res) => {
          this.DeleteLoading = false;
          this.Refresh();
          this.$notification(this.$t("DeleteSuccess"), "success");
        })
        .catch((error) => {
          this.$notification(error.response.data.error, "danger");
          this.DeleteLoading = false;
        });
    },
    SortChange(data) {
      this.filter.SortColumn = data.sortBy;
      this.filter.OrderType = data.sortDesc ? "desc" : "asc";
      this.Refresh();
    },
    Update() {
      TradeTypeRestrictionService.Update(this.items)
        .then((res) => {
          this.Refresh();
          this.$notification(this.$t("SaveSuccess"), "success");
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
    Refresh() {
      this.isLoading = true;
      TradeTypeRestrictionService.GetList(
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit,
        "",
        "asc",
        1,
        20
      )
        .then((res) => {
          this.items = res.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
  },
};
</script>

<style></style>
